"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var astrocite_core_1 = require("astrocite-core");
var constants_1 = require("./constants");
var FIELD_TRANSFORMS = new Map([
    [
        'authors',
        function (_a) {
            var authors = _a.authors;
            return {
                author: authors.map(astrocite_core_1.parseName),
            };
        },
    ],
    [
        'publishedDate',
        function (_a) {
            var publishedDate = _a.publishedDate;
            var _b = __read(publishedDate.split('-'), 3), year = _b[0], month = _b[1], day = _b[2];
            if (!year) {
                return {};
            }
            return {
                issued: {
                    'date-parts': [
                        ([year, month, day].filter(Boolean)),
                    ],
                },
            };
        },
    ],
    [
        'industryIdentifiers',
        function (_a) {
            var industryIdentifiers = _a.industryIdentifiers;
            var ident = industryIdentifiers.find(function (i) { return i.type === 'ISBN_13'; }) ||
                industryIdentifiers.find(function (i) { return i.type === 'ISBN_10'; });
            if (ident) {
                return { ISBN: ident.identifier };
            }
            return {};
        },
    ],
]);
var keys = Object.keys;
function parseItem(_a, isChapter) {
    var id = _a.id, volumeInfo = _a.volumeInfo;
    if (isChapter === void 0) { isChapter = false; }
    return keys(volumeInfo).reduce(function (obj, key) {
        var _a;
        if (!volumeInfo[key]) {
            return obj;
        }
        var transform = FIELD_TRANSFORMS.get(key);
        if (transform) {
            return __assign(__assign({}, obj), transform(volumeInfo));
        }
        var cslKey = constants_1.FIELD_MAP.get(key);
        if (cslKey) {
            if (isChapter && cslKey === 'title') {
                return __assign(__assign({}, obj), { 'container-title': volumeInfo[key] });
            }
            return __assign(__assign({}, obj), (_a = {}, _a[cslKey] = volumeInfo[key], _a));
        }
        return obj;
    }, {
        id: id,
        type: isChapter ? 'chapter' : 'book',
    });
}
function toCSL(_a, isChapter) {
    var _b = _a.items, items = _b === void 0 ? [] : _b;
    if (isChapter === void 0) { isChapter = false; }
    return items.map(function (item) { return parseItem(item, isChapter); });
}
exports.toCSL = toCSL;
